import ArrayUtils from '../utils/ArrayUtils'
import i18n from '../i18n'

const RequestManagementTypeEnum = Object.freeze({
  1: i18n.t('RequestType.NewRequest'),
  3: i18n.t('RequestType.RefuseRequest'),
  4: i18n.t('RequestType.ReturnRequest'),
  5: i18n.t('RequestType.ConfirmRequest'),
  6: i18n.t('RequestType.AllRequest'),
  // 7: i18n.t('RequestType.SuspendRequest'),
})

const RequestTypeArray = function () {
  return ArrayUtils.EnumToArray(RequestManagementTypeEnum)
}
export default { RequestManagementTypeEnum, RequestTypeArray };